module.exports = __webpack_public_path__ + "img/game_main_pc_12_off.a7e63830.png";